import {Table} from 'antd'
import fixNum from '@/script/fixNum.mjs'
import getColumnValue from './getColumnValue.mjs'

export default ({
    noRowNumber,
    rowSelection,
    summary,
    table,
}) => {
    const {
        refinedColumns: columns,
        refinedRows: rows,
    } = table

    if (summary) {
        return () => summary(rows, columns)
    }
    else {
        return function Summary() {
            if (0 === rows.length) {
                return null
            }

            const cells = []
            let index = 0

            if (! noRowNumber || rowSelection) {
                const colSpan = ! noRowNumber && rowSelection ? 2 : 1

                cells.push(
                    <Table.Summary.Cell
                        align="center"
                        colSpan={colSpan}
                        index={index}
                    >
                        合计
                    </Table.Summary.Cell>
                )

                index += colSpan
            }

            let hasSummary = false

            for (const column of columns) {
                const {align = 'right', dataIndex, summary} = column

                if (summary) {
                    hasSummary = true
                }

                const value = (() => {
                    if (! summary) {
                        return ''
                    }

                    const values = rows.map(
                        (row) => getColumnValue(row, dataIndex)
                    )

                    if ('function' === typeof summary) {
                        return summary(values)
                    }
                    else {
                        return fixNum(
                            values.reduce(
                                (sum, value) => {
                                    const v = value ? Number(value) : 0
                                    return sum + v
                                },

                                0
                            ),

                            3
                        )
                    }
                })()

                cells.push(
                    <Table.Summary.Cell
                        align={align}
                        index={index}
                    >
                        {value}
                    </Table.Summary.Cell>
                )

                index += 1
            }

            if (hasSummary) {
                return (
                    <Table.Summary fixed>
                        <Table.Summary.Row>{cells}</Table.Summary.Row>
                    </Table.Summary>
                )
            }
            else {
                return null
            }
        }
    }
}
